import { IModalAction, Modal } from "@/components/shared/Modal";
import { ReactNode, useState } from "react";
import { PreprocessStep } from "./PreprocessStep";

interface IProps {
    open: boolean;
    onClose: () => void;
}

/**
 * BulkImportDialog - Dialog for bulk importing topics
 */
export const BulkImportDialog = ({ open, onClose }: IProps) => {
    const [title, setTitle] = useState("Bulk Import Topics");
    const [subtitle, setSubtitle] = useState<string | undefined>(
        "Upload an Excel file to import topics"
    );
    const [actions, setActions] = useState<IModalAction[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [footerText, setFooterText] = useState<ReactNode>(undefined);

    const handleClose = () => {
        setTitle("Bulk Import Topics");
        setSubtitle("Upload an Excel file to import topics");
        setActions([]);
        setIsLoading(false);
        setFooterText(undefined);
        onClose();
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            title={title}
            subtitle={subtitle}
            maxWidth="md"
            showCancel={!isLoading}
            actions={actions}
            isLoading={isLoading}
            footerText={footerText}
        >
            <PreprocessStep
                onClose={handleClose}
                onTitleChange={setTitle}
                onSubtitleChange={setSubtitle}
                onActionsChange={setActions}
                onLoadingChange={setIsLoading}
                onFooterTextChange={setFooterText}
            />
        </Modal>
    );
};
